<div class="d-flex flex-column align-items-center">
  <a class="btn btn-primary btn-lg col-md-10" #downloadBtn
    [href]="sanitizeUrl('data:application/octet-stream;base64,'+exportedFile.file)" target="_blank"
    rel="noopener noreferrer" [download]="exportedFile.fileName+'.'+exportedFile.extension">
    Download </a>
</div>